import { SESSION_EXPIRE_MODAL } from "./index";
import { Modal } from "react-bootstrap";
import { ButtonConfirm } from "../buttons";
import { getCaseManagementEnabledAgencies, hideModal, TOKEN_KEY } from "../../actions";
import React from "react";
import { useDispatch } from "react-redux";
import { jwtDecode } from "jwt-decode";
import { TOKEN_EXPIRY_WARNING_SECONDS } from "../SessionMonitor";

export const SessionExpireModal = () => {
  const dispatch = useDispatch();
  const [secondsLeft, setSecondsLeft] = React.useState(null);

  React.useEffect(() => {
    const intervalId = setInterval(() => {
      const token = localStorage.getItem(TOKEN_KEY);
      if (!token) return;

      try {
        const { exp } = jwtDecode(token);
        const now = Math.floor(Date.now() / 1000);
        const timeLeft = exp - now;

        if (timeLeft <= 0) {
          setSecondsLeft(0);
          clearInterval(intervalId); // stop updating
        } else {
          if (timeLeft > TOKEN_EXPIRY_WARNING_SECONDS) {
            dispatch(hideModal(SESSION_EXPIRE_MODAL));
            clearInterval(intervalId);
          }
          setSecondsLeft(timeLeft);
        }
      } catch (e) {
        clearInterval(intervalId);
      }
    }, 1000);

    return () => clearInterval(intervalId);
  }, []);

  if (secondsLeft === null) return null;

  return (
    <Modal show centered modalType={SESSION_EXPIRE_MODAL}>
      <Modal.Body style={{ textAlign: "center", padding: "24px 32px", fontSize: "16px", lineHeight: "1.5" }}>
        <p style={{ marginBottom: "8px" }}>
          Your session will expire in <strong style={{ fontWeight: "600", fontSize: "18px" }}>{secondsLeft}</strong>{" "}
          seconds due to inactivity.
        </p>
        Please take action to remain signed in.
      </Modal.Body>

      <Modal.Footer style={{ justifyContent: "center", paddingBottom: "20px" }}>
        <ButtonConfirm
          style={{ padding: "8px 20px", borderRadius: "4px", minWidth: "160px", width: "70%" }}
          onClick={() => {
            dispatch(getCaseManagementEnabledAgencies());
            dispatch(hideModal(SESSION_EXPIRE_MODAL));
          }}
        >
          Confirm
        </ButtonConfirm>
      </Modal.Footer>
    </Modal>
  );
};
